module.exports = __webpack_public_path__ + "media/audio39.dfb110f1.mp3";